module.exports = __webpack_public_path__ + "img/50.44b9f2a1.jpg";